// Success.jsx
import { useContext, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { AuthContext } from "./auth/AuthProvider";
import axios from "axios";
import "./style/Success.css";

export default function Success() {
  const [searchParams] = useSearchParams();
  const themeSlug = searchParams.get("theme_slug");

  const {
    user,
    googleUser,
    status,
    sessionId,
    setPayed,
    setPayedStressFatigue,
    setSlug,
    apiUrl,
    themePayed,
    setThemePayed,
  } = useContext(AuthContext);

  const location = useLocation();

  useEffect(() => {
    if (!user && !googleUser) return;
    if (!themeSlug) return;

    localStorage.setItem("success", location.pathname);
    setSlug(themeSlug);

    const fetchPaymentStatus = async () => {
      try {
        let endpoint = "";

        if (googleUser) {
          endpoint = `${apiUrl}/success/googleEmail/${googleUser.email}/${themeSlug}`;
        } else if (user) {
          endpoint = `${apiUrl}/success/username/${user.username}/${themeSlug}`;
        } else {
          return;
        }

        const response = await axios.get(endpoint);

        // Set correct theme payment state
        setThemePayed((prevState) => ({
          ...prevState,
          [themeSlug]: response.data,
        }));
      } catch (error) {
        console.error("Payment check failed:", error);
      }
    };

    fetchPaymentStatus();
  }, [themeSlug, user, googleUser, apiUrl]);

  return (
    <div id="successParent">
      <div>
        <img
          src="/greenCheckmark.jpg"
          alt="checkmark"
          width={300}
          height={300}
        />
        <h1>Payment successful</h1>
        <p>Your payment has been processed successfully</p>
        <Link to="/" id="successBtn">
          Go back
        </Link>
      </div>
    </div>
  );
}
